<sdx-menu-flyout #sdxMenuFlyoutElement [closeOnClick]="true" direction="bottom-left" (click)="click($event)">
  <sdx-menu-flyout-toggle>
    <sdx-icon [iconName]="'icon-' + displayedToggleIcon" size="1"></sdx-icon>
  </sdx-menu-flyout-toggle>

  <sdx-menu-flyout-list class="table-column-fly-out-menu">
    <sdx-menu-flyout-list-item
      [iconName]="'icon-' + button.iconName"
      *ngFor="let button of buttons"
      (click)="button.clickHandler(element)"
      [disabled]="button.isDisabled"
    >
      {{ button.text | translate }}
    </sdx-menu-flyout-list-item>
  </sdx-menu-flyout-list>
</sdx-menu-flyout>
